import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import newsletterService from "../../../services/newsletterService";
import ActionCell from "./components/ActionCell";
import MDBadge from "../../../components/MDBadge";
import MDSnackbar from "../../../components/MDSnackbar";

function NewsletterList() {
  const [newsletters, setNewsletters] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    color: "info",
    title: "",
    content: "",
  });

  const closeNotification = () => setNotification({ ...notification, open: false });

  useEffect(() => {
    fetchNewsletters(page, limit, search);
  }, [page, limit, search]);

  const fetchNewsletters = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await newsletterService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "email",
        select: "email,status"
      });
      setNewsletters(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching newsletter:", error);
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    return status === "activo" ? "success" : "secondary";
  };

  const columns = [
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Estado", accessor: "status", align: "center" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = newsletters.map((news) => ({
    email: <MDTypography variant="button" fontWeight="medium">{news.email}</MDTypography>,
    status: <MDBadge badgeContent={news.status} color={getStatusColor(news.status)} variant="gradient" size="sm" />,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={news._id} action="details" icon="visibility" color="success" />
        <ActionCell id={news._id} action="edit" icon="edit" color="info" />
        <ActionCell id={news._id} action="delete" icon="delete" color="primary" onDelete={fetchNewsletters} />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <MDButton
          component={Link}
          to="/newsletters/new"
          variant="gradient"
          color="info"
        >
          Nuevo
        </MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Newsletter</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDSnackbar
        color={notification.color}
        icon={notification.color === "error" ? "warning" : "check"}
        title={notification.title}
        content={notification.content}
        dateTime="Ahora"
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />
      <Footer />
    </DashboardLayout>
  );
}

export default NewsletterList;

